module.exports = __webpack_public_path__ + "img/info-item-1.b35d49b4.png";